import { SnowplowService } from 'wanderu-service-analytics';

function tripLivecheckCompleted({
    label, tripId, itineraryId, lastScraped, price, priceDifference, selectedFare, tripSource,
}) {
    SnowplowService.fireStructuredEvent({
        category: 'react_livecheck',
        action: 'trip_completed',
        label,
        property: {
            trip_id: tripId,
            itinerary_id: itineraryId,
            last_scraped: lastScraped,
            price: price,
            price_difference: priceDifference,
            selected_fare: selectedFare,
            trip_source: tripSource,
        },
    });
}

export default {
    tripLivecheckCompleted,
};
